// TableActions.js
import React from 'react';
import { IconButton } from '@mui/material';
import { AiFillEdit, AiOutlineDelete } from 'react-icons/ai';
import { FaEye } from 'react-icons/fa';

function DataGridActions({ handleEdit, handleDelete, rowData, showDetails, showDetailsStatus }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "6px", padding: "0 4px" }}>
      {
        showDetailsStatus && (
          <IconButton onClick={() => showDetails?.(rowData)} aria-label="View details">
            <FaEye style={{ color: '#284945' }} />
          </IconButton>
        )
      }
      <IconButton onClick={() => handleEdit(rowData)}>
        <AiFillEdit style={{ color: '#466F86' }} />
      </IconButton>
      <IconButton onClick={() => handleDelete(rowData)}>
        <AiOutlineDelete style={{ color: '#962a38' }} />
      </IconButton>
    </div>
  );
}

export default DataGridActions;
